module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الإهداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى مَن جعله الله جلَّ جلاله سببًا في وجودي، أتفيَّأ بظلاله روح المعرفة، وأنهل مِن أفكاره عذوبة الجدِّ والعمل الدؤوب والصَّبر، إلى والدي الحبيب، رحمه الله وأسكنه فسيح جناته")]), _vm._v(".")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى مَن ترعرعتُ بين أحشائها هلالًا، ووَهنَتْ بالأمل لأُصبح بدرًا يعكس ضوء الشمس بأشعَّتها الذهبية لتنار به الظلماء، إلى والدتي الحنون، رحمها الله وأسكنها فسيح جناته")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى مَن أرى فيها ما لا عين رأت، ولا أذن سمعَت، وإلى مَن يخطر ببالي تجاهها ما لَم يخطر على قلب ذي بشر، حقًّا إنَّه منظرٌ مِن مناظر الجنَّة على الأرض، إلى أعزِّ إنسانة على قلبي، زوجتي الحبيبة")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى لطف الجمال، لأنَّه آية أخرى مِن عظمة الجمال، إلى مَن أرى فيها فتوَّتي وهمَّتي وعزيمتي، إلى ابنتي عهد عربون الوفاء")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى الضياء الذي يشعُّ سناه لتزداد بضيائه حياتنا بهجةً وأملًا، إلى مَن أحبُّ أن يرث المعرفة والعلم بالعمل والكدِّ، إلى ابني ضياء الدين شقيق عربون الوفاء")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى الشجرة الذي يستظلُّ بظلِّها الراكب سبعين ألف سنة، إلى المقام عند سدرة المنتهى عندها جنَّة المأوى، إلى ابنتي سدرة أملًا في الجنَّة التي وُعِدَ بها المتَّقون")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى السرور والطمأنينة، إلى رفيقة أمِّها وأبيها في شدِّ الرِّحال إلى مَن تُشَدُّ الرِّحال إليهم، إلى السارَّة سارَّة الجميلة")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى الأحفاد والأجيال المجهولة التي ستصبح بإذن الله معلومة، رغبةً بالأمل بعد الجدِّ والعمل، للعودة لرفعة خير أمَّة أُخرِجَت للناس")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى بلدي الحبيب سوريا، مهد الحضارة \"الأمّ الرؤوم")]), _vm._v("\".")])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى موطني الآخَر وتوءم بلدي \"الإمارات العربية المتحدة")]), _vm._v("\".")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى كلِّ مَن يهمُّه الأمر")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bdacd52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0